import type {ValueOf} from '~/types/value-of'

export const transactionDetailPageType = {
  transaction: 'transaction',
  block: 'block',
  logs: 'logs',
  internalTrace: 'internal-trace'
} as const
export type transactionDetailPageType = ValueOf<typeof transactionDetailPageType>;

const rootPath = '/transactions'

export default {
  getTransactionsPage() {
    return rootPath
  },
  getInternalTransactionsPage() {
    return rootPath + '/internal'
  },
  getPendingTransactionsPage() {
    return rootPath + '/pending'
  },
  getTransactionDetailPageWithTab(txnHash: string, tab?: transactionDetailPageType) {
    if (!tab) tab = transactionDetailPageType.transaction
    return this.getTransactionsPage() + `/${txnHash}` + `/${tab}`
  }
}